import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidemenu";

const Components2 = () => {
  const navigate = useNavigate();
  const [formDetails, setFormDetails] = useState([]);

  useEffect(() => {
    const fetchFormDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/formdetails`
        );

        if (response.ok) {
          const data = await response.json();
          setFormDetails(data);
        } else {
          console.error(
            "Failed to fetch form details:",
            response.status,
            response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching form details:", error);
      }
    };

    fetchFormDetails();
  }, []);

  const handleNewButtonClick = () => {
    navigate("/form");
  };

  const handleTitleClick = (formId, title) => {};

  return (
    <div className="container-fluid" style={{ display: "flex" }}>
      <Sidebar />
      <div
        className="segment-container"
        style={{ width: "100%", height: "100vh", overflowY: "auto" }}
      >
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-primary"
            style={{ height: "45px", width: "65px" }}
            onClick={handleNewButtonClick}
          >
            <span>New</span>
          </button>
        </div>

        {formDetails.length > 0 ? (
          <div className="asset-details">
            <table
              className="table table-bordered table-striped"
              style={{
                fontSize: "1.2em",
                width: "90%",
              }}
            >
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </th>

                  <th>Username</th>
                  <th>Form Attributes</th>
                  <th>Submit Action</th>
                  <th>URL Message</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {formDetails.map((form, index) => (
                  <tr
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleTitleClick(form.id, form.title)}
                  >
                    <td>
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </td>

                    <td>{form.username}</td>
                    <td>{form.formattributes}</td>
                    <td>{form.submitaction}</td>
                    <td>{form.urlmessage}</td>
                    <td>{form.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Loading form details...</p>
        )}
      </div>
    </div>
  );
};

export default Components2;
